import { Typography, Box } from "@mui/material";
import React from "react";
//import AlertComponent from "./AlertComponent";

function BrowserComponent() {
  return (
    <Box style={{ paddingLeft: 40, paddingRight: 40, marginTop: 100 }}>
      <div style={{ paddingLeft: 40, paddingRight: 40 }}>
        <Typography variant="h2" sx={{ fontWeight: "bold" }}>
          Install Cartube App
        </Typography>
        <br />
        <Typography sx={{ textAlign: "justify", maxWidth: "80%" }}>
          Cartube exclusively operates on{" "}
          <span style={{ fontWeight: "bold" }}>
            mobile (iPhone / Android) devices
          </span>
          , necessitating the use of a{" "}
          <span style={{ fontWeight: "bold" }}>QR code </span> for access. To
          begin using Cartube,{" "}
          <span style={{ fontWeight: "bold" }}>
            simply scan the provided QR code using your smartphone.
          </span>{" "}
          This unique method ensures a tailored and optimized experience solely
          available on mobile phones.
        </Typography>
      </div>

      <Box sx={{ mt: 4 }}>
        <img
          src="https://cartube.app/assets/cartube/images/qrcode_install.png"
          alt="Scan QR Code"
          width="30%"
        />
      </Box>
    </Box>
  );
}

export default BrowserComponent;
